import { initializeApp } from "firebase/app"

const firebaseConfig = {
   apiKey: process.env.FIREBASE_API_KEY,
   authDomain: "lmwebsite-6ebd0.firebaseapp.com",
   projectId: "lmwebsite-6ebd0",
   storageBucket: "lmwebsite-6ebd0.appspot.com",
   messagingSenderId: "561790253621",
   appId: "1:561790253621:web:209f8e2f5057d76a3c4f7c",
}

const app = initializeApp(firebaseConfig)

export default app
